import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
            <i className="ri-chat-smile-2-line text-primary-500 mr-2"></i>
            吃瓜群众说
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {commentsData.map((comment) => (
              <div
                key={comment.id}
                className="bg-background-100 rounded-lg p-5 flex gap-3"
              >
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-sm font-bold text-primary-600">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{comment.name}</span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{comment.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-2">
                    {comment.content}
                  </p>
                  <div className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-thumb-up-line"></i>
                    <span>{comment.likes.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}